export const UF_RESPONSE = 'UF_RESPONSE';
export const UF_ERROR = 'UF_ERROR';
export const UF_DATA = 'UF_DATA';
